// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "A tool for making Flourish embed scripts usable on our websites.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Flourish embed",
  id: "flourish-embed",
  groupsWithAccess: ["specialist_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable", "Data viz"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/flourish-embed/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "FlourishEmbedConfigTool" */ "app/components/tools/FlourishEmbedConfigTool/FlourishEmbedConfigTool"),
    loading: DynamicImportLoader,
    modules: ["FlourishEmbedConfigTool"]
  })
};

export default CONFIG;
